/**
 * Split bundled CSV option copy into a short title line + body for card UI.
 * Data is often one or more sentences with no separate title field.
 */
export function matchQuizOptionTitleDescription(text: string): {
  title: string;
  description: string;
} {
  const trimmed = text.trim();
  if (!trimmed) return { title: '', description: '' };

  const parts = trimmed.split(/(?<=[.!?])\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return { title: parts[0]!, description: parts.slice(1).join(' ').trim() };
  }
  return { title: trimmed, description: '' };
}
